import React from "react";

const SHIMMER_KEYFRAMES = `
@keyframes makulaShimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
`;

const shimmerBackground = {
  background: "linear-gradient(90deg, #e5e7eb 0%, #f3f4f6 50%, #e5e7eb 100%)",
  backgroundSize: "200% 100%",
  animation: "makulaShimmer 1.5s ease-in-out infinite",
};

export const ShimmerKeyframes = () => <style>{SHIMMER_KEYFRAMES}</style>;

type ShimmerProps = {
  className?: string;
  style?: React.CSSProperties;
  delay?: string;
};

export const Shimmer = ({ className = "", style, delay }: ShimmerProps) => (
  <div
    className={className}
    style={{
      ...shimmerBackground,
      animationDelay: delay,
      ...style,
    }}
  />
);
